import * as React from 'react';
import {type Tab} from './dataTypes/TabsWrapperType';

type TabsContextValue = {
  tabs: Tab[];
};

export const TabsContext = React.createContext<TabsContextValue>({tabs: []});

export const useTabNames = () => React.useContext(TabsContext).tabs;
